<template>
    <role-form :edit-mode="true"/>
</template>

<script>
    // import UserForm from '../../components/UserForm'
    import RoleForm from './RoleForm'

    export default {
        components: {
            RoleForm
        }
    }
</script>
